import PasswordValidator from 'password-validator';

// jsdocsReadme
const schema = new PasswordValidator();
schema.is().min(8).is().max(150).has().uppercase().has().lowercase().has().digits().has().symbols().has().not().spaces();

/**
 *
 * @param {string} password The password to be validated.
 * @returns {object} An object containing 2 keys:
 * - `isValid` (bool) - Boolean value is true if the password was determined to be valid.
 * - `unmetRequirements` (Array) - An array of strings containing the unmet requirements.
 */
function validatePassword(password) {
  const unmetRequirements = schema.validate(password, {
    list: true
  });
  // password can fail one of digits, symbols, lower, or upper
  // but must be 8+ chars
  return {
    isValid: unmetRequirements.length <= 1 && !['min', 'max'].includes(unmetRequirements[0]),
    unmetRequirements
  };
}

/**
 * A string that can be used in an error message.
 */
const invalidPwMessage = 'The password must be at least 8 characters and must have 3 of the following' + ' characteristics: Uppercase, lowercase, numbers, or symbols (&%$#@!*)';

export { invalidPwMessage, validatePassword };
//# sourceMappingURL=amtrav-password-validator.esm.js.map
